import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const copyShotclass = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.COPY_SHOTCLASS,
    data
  );
};

export default copyShotclass;
